import { ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { OccEndpointsService } from '@spartacus/core';
import moment from 'moment';
import { BehaviorSubject, Observable, retry, Subject, takeUntil } from 'rxjs';
import { CookieService } from 'src/app/customServices/cookie.service';
import { KbWarrantyService } from 'src/app/services/feature/MyWarranty/warranty.service';
import { KbFileService } from 'src/app/services/feature/myacc-popup-fileService/kbfileService.service';
import { NGXLogger } from "ngx-logger";
import { AbstractControl, ValidationErrors } from '@angular/forms';

export function quantityRequiredValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  return value === 0 ? { required: true } : null;
}


@Component({
  selector: 'app-kb-submit-warranty-claim',
  templateUrl: './kb-submit-warranty-claim.component.html',
  styleUrls: ['./kb-submit-warranty-claim.component.scss'],
  standalone: false
})
export class KbSubmitWarrantyClaimComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  showCustomerList = false;
  userDetails$: any;
  warrantyData$: Observable<any> = this.kbWarrantyService.getSubmitWarranty();
  selectedCustomerId: any;
  isReviewed = false;
  isUploadAble = false;
  isFormContainsError: boolean = false;
  isFormFilledSuccessfully: boolean = false;
  productNotFound = undefined;
  today: Date = new Date();
  isDuplicateFile: boolean = false;
  isMaxFileSize: boolean = false;
  isUploadfileSuccess: boolean = false;
  isAtleastOnefileIsThere: boolean = true;
  fileLength$: Observable<any> = this.fileService.getCurrentFileCount();
  fileCurrentFiles$: Observable<any> = this.fileService.getCurrentFilesInfo();
  submittedSuccessFully: any;
  submitapierror$ = new BehaviorSubject(null);
  baseUrl: string = '';
  isDealerSelected = false;
  isDistributerSelected = false;
  vehicleToChassisMap: any;
  isVehicleManufacturerSelect = false;
  bsconfigDate: string = '';
  @ViewChild('popUpBoxFileUpload') PopUpBoxFileUpload: any;
  remDateGreatThanServ$ = new BehaviorSubject([]);
  showAxlePosition$ = new BehaviorSubject([]);
  prodFound$ = new BehaviorSubject([]);
  prodFound = new Map([]);
  isDistributor = false;

  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  warrantyClaimApplication = new FormGroup({
    soldTo: new FormControl(null),
    claimSubmitDate: new FormControl({ value: '', disabled: true }),
    warrantyClaimNumber: new FormControl(''),
    claimRefNumber: new FormControl('', { validators: Validators.required }),
    businessTypes: new FormControl(null, { validators: Validators.required }),
    email: new FormControl('', { validators: Validators.required }),
    phoneNumber: new FormControl(''),
    email1: new FormControl('', { validators: Validators.email }),
    email2: new FormControl('', { validators: Validators.email }),
    //vehicle section
    typeOfOperation: new FormControl(null, { validators: Validators.required }),
    vinNumber: new FormControl(null, [Validators.maxLength(17),]),
    vehicleId: new FormControl(''),
    vehicleManufacturer: new FormControl(null),
    chassis: new FormControl(''),
    engineManufacturers: new FormControl(null),
    //claim info section
    claimTypes: new FormControl('', { validators: Validators.required }),
    recallValue: new FormControl(null),
    tagSerialNumber: new FormControl(''),
    primaryComplaints: new FormControl(null, { validators: Validators.required }),
    natureOfDefect: new FormControl(''),
    dealerCode: new FormControl({ value: null, disabled: true }),
    //array-- Dropdown dynamic form
    partInfoDataList: this.fb.array([]),
  });

  partInformationNumberForm() {
    return new FormGroup({
      customerPartNumber: new FormControl('', { validators: Validators.required }),
      partNumber: new FormControl(''),
      quantity: new FormControl('', [Validators.required, quantityRequiredValidator]),
      typeNumber: new FormControl(''),
      description: new FormControl(''),
      replacementTypes: new FormControl(null, { validators: Validators.required }),
      mileageInService: new FormControl('', [Validators.required, Validators.maxLength(7), Validators.pattern('^[0-9]*$')]),
      scale: new FormControl(null, { validators: Validators.required }),
      axlePositions: new FormControl(null),
      inServiceString: new FormControl('', { validators: Validators.required }),
      removedFromServiceString: new FormControl('', { validators: Validators.required }),
      serialNumber: new FormControl(''),
      dateCode: new FormControl(''),
      partsDisposition: new FormControl('', { validators: Validators.required }),
      labourRequested: new FormControl(true, { validators: Validators.required }),
      requestedPartAmount: new FormControl('', { validators: Validators.required }),
      requestedHandlingAmount: new FormControl(''),
      hourlyLabourRate: new FormControl(null),
      repairTime: new FormControl(null),
      labourAmount: new FormControl({ value: null, disabled: true }),
      otherCost: new FormControl(''),
      otherCostDescription: new FormControl(''),
      totalCost: new FormControl({ value: null, disabled: true }),
      entryNumber: new FormControl(''),
    });
  }

  get warrantyClaimForm() {
    return this.warrantyClaimApplication.controls;
  }
  get partInforform() {
    return this.partInformationNumberForm()?.controls;
  }

  get partInfoDataList(): FormArray {
    return this.warrantyClaimApplication.get('partInfoDataList') as FormArray;
  }

  getPartInfoControl(index: number, controlName: string): any {
    return this.warrantyClaimApplication.get('partInfoDataList').get(index.toString()).get(controlName);
  }

  @HostListener('keydown.escape')
  @HostListener('document:click')
  onDocumentClick() {
    this.showCustomerList = false;
  }
  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.charCode;

    // Allow: only digits (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  selectedCustomerUnit(event) {
    this.showCustomerList = false;
    this.selectedCustomerId = event;
  }

  showSearchResults($event: Event) {
    $event.stopPropagation();
    this.showCustomerList = !this.showCustomerList;
  }

  constructor(
    private kbWarrantyService: KbWarrantyService,
    private fb: FormBuilder,
    private cookieService: CookieService,
    private dialog: MatDialog,
    private fileService: KbFileService,
    private cdr: ChangeDetectorRef,
    private scroller: ViewportScroller,
    private endPointService: OccEndpointsService,
    private logger: NGXLogger
  ) {
    this.partInfoDataList.push(this.partInformationNumberForm());
    this.baseUrl = this.endPointService.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit() {
    const customerId = this.cookieService.getCookieValue(`customerIdNA`);
    const state = history.state;

    this.warrantyData$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.logger.info(" NA/mywarranty/getsubmitwarranty First API call after navigation of submit claim", data);
      this.bsconfigDate = data.dateFormat
      this.selectedCustomerId = data.b2bUnitsWSList.find((item) => item.uid === customerId);
      this.warrantyClaimApplication.patchValue({
        soldTo: state ? state?.warranty?.soldTo : this.selectedCustomerId?.uid,
        claimSubmitDate: data.claimSubmitDate,
        email: data?.customer?.displayUid,
        phoneNumber: data?.customer?.phone,
        claimTypes: data?.claimTypes[0]?.code,
      });
      if (state?.warranty) {
        this.selectedCustomerId = data.b2bUnitsWSList.find((item) => item.uid === state?.warranty?.soldTo);;
        this.warrantyClaimApplication.patchValue({
          soldTo: state?.warranty?.soldTo,
          email: state?.warranty?.email,
          email1: state?.warranty?.email1,
          email2: state?.warranty?.email2,
          claimTypes: state?.warranty?.claimType,
          businessTypes: state?.warranty?.businessType,
          primaryComplaints: state?.warranty?.primaryComplaint,
          typeOfOperation: state?.warranty?.typeOfOperation,
          vehicleManufacturer: state?.warranty?.vehicleManufacturer,
          vinNumber: state?.warranty?.vinNumber,
          engineManufacturers: state?.warranty?.engineManufacturer,
          natureOfDefect: state?.warranty?.natureOfDefect,
          tagSerialNumber: state?.warranty?.tagSerialNumber,
          claimRefNumber: state?.warranty?.claimRefNumber
        });
        if (state?.warranty?.businessType) {
          this.onBusinessTypeChange('', state?.warranty?.businessType, state?.warranty?.dealerCode)
        }
        for (let index = 0; index < state?.warranty?.partsInformation?.length; index++) {
          if (index >= 1) {
            this.partInfoDataList.push(this.partInformationNumberForm());
          }
          const partData = state?.warranty?.partsInformation[index];
          this.getPartInfoControl(index, 'customerPartNumber').patchValue(partData?.customerPartNumber);
          if (partData?.customerPartNumber) {
            this.isEligibleForReturn('', index, partData?.customerPartNumber);


          }

          this.getPartInfoControl(index, 'quantity').patchValue(partData?.quantity);
          this.getPartInfoControl(index, 'replacementTypes').patchValue(partData?.replacementType);
          this.getPartInfoControl(index, 'mileageInService').patchValue(partData?.mileageInService);
          this.getPartInfoControl(index, 'scale').patchValue(partData?.scale);
          //patch axle position
          if (partData?.axlePosition) {
            this.getPartInfoControl(index, 'axlePositions').patchValue(partData?.axlePosition);

          }


        }
      }
      this.getPartInfoControl(0, 'partsDisposition').patchValue(data?.partsDisposition?.[0]?.code);
    });
    this.cdr.detectChanges();
  }

  onClaimTypeChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    if (value === 'Recall') {
      this.warrantyClaimApplication.get('recallValue')?.setValidators([Validators.required]);
    } else {
      this.warrantyClaimApplication.get('recallValue')?.clearValidators();
      this.warrantyClaimApplication.value.recallValue = '';
      this.warrantyClaimForm['recallValue'].patchValue('');
    }
  }

  isEligibleForReturn(event, i: number, partNum?: any) {
    if (event) {
      event.stopPropagation();

    }
    const value = partNum ? partNum : event.target.value
    this.kbWarrantyService.getProductForCustomPart(value, this.selectedCustomerId?.uid).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.getPartInfoControl(i, 'entryNumber').patchValue(i);
      if (res.productData) {
        const axlePosition = [];
        this.showProd(i, true);
        this.getPartInfoControl(i, 'typeNumber').patchValue(res.productData.typenumber);
        this.getPartInfoControl(i, 'partNumber').patchValue(res.productData.code);
        this.setAxlePosition(res, i, axlePosition);
        if (res.productData?.coreGroupDescription) {
          this.getPartInfoControl(i, 'description').patchValue(res.productData?.coreGroupDescription);
        }
        else {
          this.getPartInfoControl(i, 'description').patchValue(res.productData?.description);

        }
        this.getPartInfoControl(i, 'totalCost').patchValue(res?.productData?.totalCost);
        this.productNotFound = undefined;
      } else {

        this.getPartInfoControl(i, 'entryNumber').patchValue(i);
        this.getPartInfoControl(i, 'customerPartNumber').reset();
        this.getPartInfoControl(i, 'totalCost').reset();
        this.getPartInfoControl(i, 'description').reset();
        this.getPartInfoControl(i, 'typeNumber').reset();
        this.getPartInfoControl(i, 'partNumber').reset();
        this.hideAxlePositions(i);
        this.showProd(i, false);
        this.productNotFound = res?.errorMsg;
      }
      this.cdr.detectChanges();
    });
  }

  private showProd(i: number, setprod: boolean) {
    this.prodFound.set(i, setprod);
    //Destructure Map
    const prodfound = Array.from(this.prodFound);
    if (prodfound) {
      this.prodFound$.next(prodfound);
    }
  }

  private hideAxlePositions(i: number) {
    if (this.getPartInfoControl(i, 'axlePositions')) {
      this.getPartInfoControl(i, 'axlePositions').reset();
      this.getPartInfoControl(i, 'axlePositions').removeValidators(Validators.required);
      this.getPartInfoControl(i, 'axlePositions').updateValueAndValidity();
      const ap = this.showAxlePosition$.getValue();
      const axlePosition = [];
      if ((ap?.length ?? 0) > 0) {
        ap.forEach(indexRes => {
          if (indexRes != i) {
            axlePosition.push(indexRes);
          }
        });
      }
      else if (ap['index']) {
        axlePosition.push(ap);
      }
      axlePosition?.map(resValue => {
        if (resValue['index'] === i) {
          resValue['value'] = false;
        }
      });
      const newAxle = axlePosition.filter(filter => filter['index'] === i);
      if (!newAxle['index']) {
        axlePosition.push({
          index: i,
          value: false
        });
      }
      this.showAxlePosition$.next(axlePosition);
    }
  }

  private setAxlePosition(res: any, i: number, axlePosition: any[]) {
    if (res?.productData?.showAxlePosition) {
      const ap = this.showAxlePosition$.getValue();
      if ((ap?.length ?? 0) > 0) {
        ap.forEach(indexRes => {
          if (indexRes != i) {
            axlePosition.push(indexRes);
          }
        });
      }
      else if (ap['index']) {
        axlePosition.push(ap);
      }
      axlePosition?.map(resValue => {
        if (resValue['index'] === i) {
          resValue['value'] = true;
        }
      });
      const newAxle = axlePosition.filter(filter => filter['index'] === i);
      if (!newAxle['index']) {
        axlePosition.push({
          index: i,
          value: true
        });
      }
      this.showAxlePosition$.next(axlePosition);
      this.getPartInfoControl(i, 'axlePositions').addValidators(Validators.required);
    }
    else {
      const ap = this.showAxlePosition$.getValue();
      if ((ap?.length ?? 0) > 0) {
        ap.forEach(indexRes => {
          if (indexRes != i) {
            axlePosition.push(indexRes);
          }
        });

      }
      else if (ap['index']) {
        axlePosition.push(ap);
      }
      axlePosition?.map(resValue => {
        if (resValue['index'] === i) {
          resValue['value'] = false;
        }
      });
      const newAxle = axlePosition.filter(filter => filter['index'] === i);
      if (!newAxle['index']) {
        axlePosition.push({
          index: i,
          value: false
        });
      }

      this.showAxlePosition$.next(axlePosition);
      if (this.getPartInfoControl(i, 'axlePositions')) {
        this.getPartInfoControl(i, 'axlePositions').removeValidators(Validators.required);
        this.getPartInfoControl(i, 'axlePositions').updateValueAndValidity();
      }
    }
  }

  getAxlePosition(i: any, axlePosition: any) {
    if (axlePosition) {
      const ret = axlePosition?.filter(res => res?.index === i)
      return ret?.[0]?.value;
    }
    return false
  }

  getProdDisplay(i: any, prodInfo: any) {
    if (prodInfo) {
      const ret = prodInfo?.filter(res => res['0'] === i)
      return ret?.[0]?.['1'];
    }
    return false
  }
  onBusinessTypeChange(event, busTyp?: any, dealerCode?: any) {
    if (event) {
      event.stopPropagation();
    }
    const value = busTyp ? busTyp : event.target.value

    this.getPartInfoControl(0, 'labourRequested').patchValue(false);
    if (value === 'DEALER') {
      this.kbWarrantyService.getDealerCode(this.selectedCustomerId?.uid).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.warrantyClaimForm.dealerCode.enable();
        this.warrantyClaimForm.dealerCode.addValidators(Validators.required);
        this.warrantyClaimForm.dealerCode.patchValue(res?.dealerCode ? res?.dealerCode : dealerCode);
        this.isDealerSelected = true;
        this.isDistributerSelected = false;
        this.warrantyClaimForm.vinNumber.addValidators(Validators.required);
        this.cdr.detectChanges();
      })
    } else if (value === 'DISTRIBUTER') {
      this.isDistributerSelected = true;
      this.isDealerSelected = false;
      this.warrantyClaimForm.dealerCode.removeValidators(Validators.required);
      this.warrantyClaimForm.dealerCode.updateValueAndValidity();
      this.warrantyClaimForm.vinNumber.removeValidators(Validators.required);
      this.warrantyClaimForm.vinNumber.updateValueAndValidity();
      this.cdr.detectChanges();
    } else {
      this.warrantyClaimForm.vinNumber.addValidators(Validators.required);
      this.isDealerSelected = false;
      this.warrantyClaimForm.dealerCode.disable();
      this.warrantyClaimForm.dealerCode.removeValidators(Validators.required);
      this.warrantyClaimForm.dealerCode.updateValueAndValidity();
      this.isDistributerSelected = false;
      this.cdr.detectChanges();
    }
    this.businessTypeChange();
  }

  onVehicleManufacturerChange(event, chassisData) {
    event.stopPropagation();
    this.isVehicleManufacturerSelect = true;
    this.vehicleToChassisMap = chassisData.filter((item) => item?.key?.code === event.target.value);
  }
  formatDateCustom(date: Date): string {

    // let searchDate = date.toLocaleDateString();
    const searchDate = moment(date).format(this.bsconfigDate.toUpperCase());
    return searchDate;
  }
  addPartNumber() {
    //fetch mileage , scale, date in service , date removed from service from 1st part
    const mileage = this.getPartInfoControl(0, 'mileageInService')?.value;
    const scale = this.getPartInfoControl(0, 'scale')?.value;
    const servDate = this.getPartInfoControl(0, 'inServiceString')?.value;
    const remDate = this.getPartInfoControl(0, 'removedFromServiceString')?.value;
    this.partInfoDataList.push(this.partInformationNumberForm());
    const arrayIndex = this.partInfoDataList?.length - 1;
    if (arrayIndex > 0) {
      this.getPartInfoControl(arrayIndex, 'mileageInService').patchValue(mileage);
      this.getPartInfoControl(arrayIndex, 'scale').patchValue(scale);
      this.getPartInfoControl(arrayIndex, 'inServiceString').patchValue(servDate);
      this.getPartInfoControl(arrayIndex, 'removedFromServiceString').patchValue(remDate);
      this.isDistributor ? this.getPartInfoControl(arrayIndex, 'labourRequested').patchValue(false) :
        this.getPartInfoControl(arrayIndex, 'labourRequested').patchValue(true);
      this.isDistributor ? this.getPartInfoControl(arrayIndex, 'requestedHandlingAmount').disable() : '';
      this.isDistributor ? this.getPartInfoControl(arrayIndex, 'hourlyLabourRate').disable() : '';
      this.isDistributor ? this.getPartInfoControl(arrayIndex, 'repairTime').disable() : '';
      this.isDistributor ? this.getPartInfoControl(arrayIndex, 'otherCost').disable() : '';
      this.isDistributor ? this.getPartInfoControl(arrayIndex, 'otherCostDescription').disable() : '';
    }
  }

  removePartInfo(i) {
    this.partInfoDataList.removeAt(i);
  }

  submitReviewWarrantyClaim() {
    //Read dates
    this.submitapierror$.next(null)
    this.remDateGreatThanServ$.next([]);
    const data: any = this.warrantyClaimApplication.getRawValue();
    const datesIssue = [];
    data.partInfoDataList.forEach((part, index = 0) => {
      if (part.inServiceString > part.removedFromServiceString) {
        datesIssue.push(true)
        this.getPartInfoControl(index, 'removedFromServiceString').setErrors({ 'incorrect': true });
      }
      else {
        datesIssue.push(false);
        this.getPartInfoControl(index, 'removedFromServiceString').setErrors(null);
      }
      index += 1
    });
    if ((datesIssue?.length ?? 0) > 0) {
      this.remDateGreatThanServ$.next(datesIssue)
    }
    if (this.warrantyClaimApplication.valid) {
      this.isFormContainsError = false;
      this.warrantyClaimForm.soldTo.patchValue(this.selectedCustomerId?.uid);
      this.kbWarrantyService.submitWarrantyForReview(this.warrantyClaimApplication.value).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.isReviewed = true;
        this.isFormFilledSuccessfully = true;
        this.scroller.scrollToPosition([0, 150]);
        this.cdr.detectChanges();
      }, () => {
        this.isFormContainsError = true;
      });
    } else {
      this.isFormContainsError = true;
      this.scroller.scrollToPosition([0, 150]);
      this.warrantyClaimApplication.markAllAsTouched();
      this.cdr.detectChanges();
    }
  }

  async submitWarrantyClaim() {
    if (!this.warrantyClaimApplication.valid) {
      this.logger.info("this log is if condtion warranty clain Application invalid")
      return;
    }
    const data: any = this.warrantyClaimApplication.getRawValue();
    this.warrantyClaimForm.soldTo.patchValue(this.selectedCustomerId?.uid);
    data.partInfoDataList.forEach((part, index = 0) => {
      const partInService = moment(part.inServiceString).format(this.bsconfigDate.toUpperCase())
      this.getPartInfoControl(index, 'inServiceString').patchValue(partInService);

      const remFromService = moment(part.removedFromServiceString).format(this.bsconfigDate.toUpperCase());
      this.getPartInfoControl(index, 'removedFromServiceString').patchValue(remFromService);
      index += 1

    });


    this.kbWarrantyService.testWarrentyAPINA(this.warrantyClaimApplication.getRawValue()).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.logger.info("TestAPINA", res);
      this.isFormFilledSuccessfully = false;
      if (res?.kbStatusMessageWSDTO?.status === 'error') {
        this.submitapierror$.next(res?.kbStatusMessageWSDTO?.message)
      }
      else {
        this.submittedSuccessFully = res;
        this.scroller.scrollToPosition([0, 150]);
        this.warrantyClaimForm.warrantyClaimNumber.patchValue(res?.claimNumber);
        this.warrantyClaimApplication.disable();
        this.submitapierror$.next(null)
        this.cdr.detectChanges();
      }
    });
  }

  uploadFile(index: number) {
    const dialogRef = this.dialog.open(this.PopUpBoxFileUpload, {
      data: {
        index: index,
      },
    });
  }

  closePopUpBoxFileUpload() {
    this.dialog.closeAll();
  }

  fileSelector(event: any) {
    const files = Object.values(event.files);
    const TotalFileSizeExceeds = this.fileService.isTotalFileSizeLessThan9MB();

    files.map((file: File) => {
      if (!this.fileService.isFileSizeLessThan9MB(file) && this.fileService.isAtLeastOneFilePresent()) {
        this.isMaxFileSize = true;
        this.fileService.clearAllFiles();
      }
      else if (!this.fileService.isNotDuplicate(file.name)) {
        this.isDuplicateFile = true;
      }
      else {
        this.fileService.addFile(file);
        this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();
        if (!this.fileService.isTotalFileSizeLessThan9MB()) {
          this.fileService.clearAllFiles();
          this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();
          this.isMaxFileSize = true;
        }
        this.cdr.detectChanges();
      }
    });
    if (this.isMaxFileSize) {
      this.fileService.clearAllFiles();
    }

    this.timeout = setTimeout(() => {
      this.isDuplicateFile = false;
      this.isMaxFileSize = false;
      this.isUploadfileSuccess = false;
    }, 10000);
  }
  removefile(file: File) {
    this.fileService.deleteFile(file.name);
    this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();
  }

  fileUploadFunction() {
    this.isAtleastOnefileIsThere = this.fileService.isAtLeastOneFilePresent();
    if (this.isAtleastOnefileIsThere) {
      this.isUploadfileSuccess = true;
    }
    this.timeout = setTimeout(() => {
      this.isUploadfileSuccess = false;
    }, 7000);
  }
  businessTypeChange() {
    const distributor = this.warrantyClaimForm.businessTypes.value == 'DISTRIBUTER';
    this.isDistributor = distributor;
    const fleet = this.warrantyClaimForm.businessTypes.value == 'FLEET';
    const dealer = this.warrantyClaimForm.businessTypes.value == 'DEALER';
    const oem = this.warrantyClaimForm.businessTypes.value == 'OEM';
    const fleetOrDealer = fleet || dealer || oem;
    const partInfoArray = this.warrantyClaimApplication.get('partInfoDataList') as FormArray;
    for (let i = 0; i < partInfoArray?.length; i++) {
      const currentGroup = partInfoArray.at(i) as FormGroup;
      const requestedHandlingAmount = currentGroup.get('requestedHandlingAmount') as FormControl;
      const hourlyLabourRate = currentGroup.get('hourlyLabourRate') as FormControl;
      const repairTime = currentGroup.get('repairTime') as FormControl;
      const otherCost = currentGroup.get('otherCost') as FormControl;
      const otherCostDescription = currentGroup.get('otherCostDescription') as FormControl;
      const requestedPartAmount = currentGroup.get('requestedPartAmount') as FormControl;
      const entryNumber = currentGroup.get('entryNumber') as FormControl;

      const labourAmount = currentGroup.get('labourAmount') as FormControl;
      const totalCost = currentGroup.get('totalCost') as FormControl;
      const labourRequestedValue = currentGroup.get('labourRequested').value;

      requestedPartAmount.setValue('');
      requestedHandlingAmount.setValue('');
      hourlyLabourRate.setValue('');
      repairTime.setValue('');
      otherCost.setValue('');
      otherCostDescription.setValue('');
      // entryNumber.setValue('');

      labourAmount.setValue('');
      totalCost.setValue('');

      if (distributor) {
        requestedHandlingAmount.disable();
        hourlyLabourRate.disable();
        repairTime.disable();
        otherCost.disable();
        otherCostDescription.disable();
        entryNumber.disable();
      } else {
        requestedHandlingAmount.enable();
        hourlyLabourRate.enable();
        repairTime.enable();
        otherCost.enable();
        otherCostDescription.enable();
        entryNumber.enable();
      }
      if (fleetOrDealer && !labourRequestedValue) {
        hourlyLabourRate.disable();
        repairTime.disable();
      } else if (fleetOrDealer && labourRequestedValue) {
        requestedHandlingAmount.enable();
        hourlyLabourRate.enable();
        repairTime.enable();
        otherCost.enable();
        otherCostDescription.enable();
        entryNumber.enable();
      }
    }
  }
  uiCostCalculator() {
    const partInfoArray = this.warrantyClaimApplication.get('partInfoDataList') as FormArray;
    for (let i = 0; i < partInfoArray?.length; i++) {
      const currentGroup = partInfoArray.at(i) as FormGroup;
      const labourAmount = currentGroup.get('labourAmount') as FormControl;
      const totalCost = currentGroup.get('totalCost') as FormControl;
      const quantity = currentGroup.get('quantity').value;
      const hourlyLabourRate = currentGroup.get('hourlyLabourRate').value;
      const repairTime = currentGroup.get('repairTime').value;
      const requestedPartAmountValue = currentGroup.get('requestedPartAmount').value * quantity;
      const requestedHandlingAmount = currentGroup.get('requestedHandlingAmount').value * quantity;
      const otherCost = currentGroup.get('otherCost').value * quantity;
      const labourAmountCAlc = (hourlyLabourRate * repairTime);
      if (labourAmountCAlc != 0) {
        labourAmount.setValue(labourAmountCAlc);
      }
      const TotalCostCalc = requestedPartAmountValue + requestedHandlingAmount + (labourAmountCAlc * quantity) + otherCost

      totalCost.setValue(TotalCostCalc);
    }
  }

  ngOnDestroy() {
    this.fileService.clearAllFiles();
    this.destroy$.next();
    this.destroy$.complete();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
